export const T = {
  en_GB: {
    companyToLookUp: "Company to look up",
    runLookup: "Run lookup",
    searchDifferentCompany: "Search for a different company",
    cancel: "Cancel",
    searchLabel: "Search Enin by company name",
    searchPlaceholder: "Company name",
    search: "Search",
    noResults: "No companies found matching",
    autoResolveFailed:
      "The company could not be resolved automatically from the client's organisation number and country. Search for it by name instead.",
    incompleteMessage: "Run the company lookup",
  },
  nb_NO: {
    companyToLookUp: "Selskap som slås opp",
    runLookup: "Kjør oppslag",
    searchDifferentCompany: "Søk etter et annet selskap",
    cancel: "Avbryt",
    searchLabel: "Søk i Enin etter selskapsnavn",
    searchPlaceholder: "Selskapsnavn",
    search: "Søk",
    noResults: "Ingen selskaper funnet for",
    autoResolveFailed:
      "Selskapet kunne ikke utledes automatisk fra kundens organisasjonsnummer og land. Søk etter det med navn i stedet.",
    incompleteMessage: "Kjør selskapsoppslaget",
  },
} as const;
